import axios from "../../axios/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ALL_USER_LOAD_FAIL,
  ALL_USER_LOAD_REQUEST,
  ALL_USER_LOAD_SUCCESS,
  USER_APPLY_JOB_FAIL,
  USER_APPLY_JOB_REQUEST,
  USER_APPLY_JOB_SUCCESS,
  USER_LOAD_FAIL,
  USER_LOAD_REQUEST,
  USER_LOAD_SUCCESS,
  USER_LOGOUT_FAIL,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_SIGNIN_FAIL,
  USER_SIGNIN_REQUEST,
  USER_SIGNIN_SUCCESS,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAIL,
  USER_SIGNUP_REQUEST,
} from "../constants/userConstant";
import { COMPANY_CREATE_SUCCESS } from "../constants/companyConstant";

export const userSignInAction = (user, navigate) => async (dispatch) => {
  dispatch({ type: USER_SIGNIN_REQUEST });
  try {
    const { data } = await axios.post("/api/user/login", user);
    console.log(data);
    localStorage.setItem("userInfo", JSON.stringify(data));
    dispatch({
      type: USER_SIGNIN_SUCCESS,
      payload: data,
    });
    if (data.user.type === "admin") {
      navigate("/admin/dashboard");
    } else {
      navigate("/");
    }
    toast.success("Login Successfully!", { position: "bottom-right" });
  } catch (error) {
    dispatch({
      type: USER_SIGNIN_FAIL,
      payload: error.response.data.message,
    });
    console.log(error.response.data.errors[0].msg);
    toast.error(error.response.data.errors[0].msg, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }
};

export const userSignUpActionBusiness =
  (user, company, navigate) => async (dispatch) => {
    dispatch({ type: USER_SIGNUP_REQUEST });
    axios
      .post("/api/user/register", user)
      .then((res) => {
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        dispatch({
          type: USER_SIGNUP_SUCCESS,
          payload: res.data,
        });
        axios
          .post("/api/company", company)
          .then((res) => {
            const userInfoWithCompanyId = {
              ...JSON.parse(localStorage.getItem("userInfo")),
              company_id: res.data.company_id,
            };
            localStorage.setItem(
              "userInfo",
              JSON.stringify(userInfoWithCompanyId)
            );
            dispatch({
              type: COMPANY_CREATE_SUCCESS,
              payload: res.data,
            });

            navigate("/");
            toast.success("Sign up Successfully!");
          })
          .catch((err) => {
            toast.error(err.message);
          });
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

export const userSignUpAction = (user, navigate) => async (dispatch) => {
  dispatch({ type: USER_SIGNUP_REQUEST });
  console.log(user);
  try {
    const { data } = await axios.post("/api/user/register", user);
    localStorage.setItem("userInfo", JSON.stringify(data));
    dispatch({
      type: USER_SIGNUP_SUCCESS,
      payload: data,
    });
    navigate("/login");
    toast.success("Registered Successfully!");
  } catch (error) {
    console.log(error);
    dispatch({
      type: USER_SIGNUP_FAIL,
      payload: error.response.data.message,
    });
    toast.error(error.response.data.message);
  }
};

//log out action
export const userLogoutAction = (navigate) => async (dispatch) => {
  dispatch({ type: USER_LOGOUT_REQUEST });
  try {
    localStorage.removeItem("userInfo");
    dispatch({
      type: USER_LOGOUT_SUCCESS,
      payload: null,
    });
    window.location = "/";
    toast.success("Log out successfully!", { position: "bottom-right" });
  } catch (error) {
    dispatch({
      type: USER_LOGOUT_FAIL,
      payload: error.response.data.error,
    });
    toast.error(error.response.data.error);
  }
};

//user profile action
export const userProfileAction = () => async (dispatch) => {
  dispatch({ type: USER_LOAD_REQUEST });
  try {
    dispatch({
      type: USER_LOAD_SUCCESS,
      payload: JSON.parse(localStorage.getItem("userInfo")),
    });
  } catch (error) {
    dispatch({
      type: USER_LOAD_FAIL,
      payload: error.response.data.error,
    });
  }
};

//all user action
export const allUserAction = () => async (dispatch) => {
  dispatch({ type: ALL_USER_LOAD_REQUEST });
  try {
    const { data } = await axios.get("/api/user/getAllUsers");
    dispatch({
      type: ALL_USER_LOAD_SUCCESS,
      payload: data,
    });
    console.log(data);
  } catch (error) {
    dispatch({
      type: ALL_USER_LOAD_FAIL,
      payload: error.response.data.error,
    });
  }
};

//user job apply action
export const userApplyJobAction = (job) => async (dispatch) => {
  dispatch({ type: USER_APPLY_JOB_REQUEST });
  try {
    const { data } = await axios.post("/api/user/jobhistory", job);

    dispatch({
      type: USER_APPLY_JOB_SUCCESS,
      payload: data,
    });
    toast.success("Apply Successfully for this Job!");
  } catch (error) {
    dispatch({
      type: USER_APPLY_JOB_FAIL,
      payload: error.response.data.error,
    });
    toast.error(error.response.data.error);
  }
};
